import styled from 'styled-components';

export const DesktopListingItemBoardTypeContainer = styled.div`
  display: flex;
  gap: 4px;
`;

export const BoardTypesWrapper = styled.div`
  padding: 4px;
  height: 23px;
  background-color: ${({ theme }) => theme.palette.NL30};
  border-radius: 4px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const BoardTypesItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
`;

export const BoardTypesItem = styled.div`
  padding: 4px;
  display: flex;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.palette.NL20};
  width: 100%;
`;
